import instance from "../api/axios";
import { ApiRequest } from "../types/requests/ApiRequest";
import { ApiResponse } from "../types/responses/ApiResponse";
import { GetProductListRequest } from "../types/requests/GetProductListRequest";
import { GetProductListResponse } from "../types/responses/GetProductListResponse";

export const productService = {
  getProductList: async (request: ApiRequest<GetProductListRequest>): Promise<ApiResponse<GetProductListResponse>> => await instance.post<ApiRequest<GetProductListRequest>,ApiResponse<GetProductListResponse>>('/p1/Product/get_product_list', request),
}